import React from 'react';

export default function HighText({ children, design = '', style }) {
	return (
		<p className={`${design} HighText`} style={style}>
			{children}
		</p>
	);
}
